import { jsx as _jsx } from "react/jsx-runtime";
const LABELS = {
    local: 'LOCAL',
    cloud: 'CLOUD',
};
const COLORS = {
    local: '#2f9e44',
    cloud: '#1971c2',
};
/** Small environment indicator badge. Should be hidden in production builds. */
export function ProfileBadge({ profile }) {
    return (_jsx("span", { "data-testid": "profile-badge", style: {
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 1,
            color: 'white',
            backgroundColor: COLORS[profile],
        }, children: LABELS[profile] }));
}
//# sourceMappingURL=ProfileBadge.js.map